// Testimonials.jsx
import React from 'react';
import '../../assets/css/student/home/Testimonies.css';
import { FaStar } from 'react-icons/fa';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Ahmed Hassan",
      role: "10th Grade Student",
      image: "https://img.freepik.com/free-photo/portrait-cute-smiling-boy-cafe_23-2148436234.jpg?semt=ais_hybrid&w=740&q=80",
      title: "Ahmed's Journey",
      text: "The uniform support program changed my life. I no longer felt different from my classmates and could focus on my studies without worrying about what to wear."
    },
    {
      id: 2,
      name: "Fatima Khan",
      role: "Beneficiary Parent",
      image: "https://www.shutterstock.com/shutterstock/videos/1034450006/thumb/9.jpg?ip=x480",
      title: "Fatima's Experience",
      text: "Thanks to the fee assistance, my daughter can continue her education. This support has lifted a huge burden from our family and given us hope for a better future."
    },
    {
      id: 3,
      name: "Ali Raza",
      role: "University Student",
      image: "https://img.freepik.com/free-photo/smiling-adult-businessman-writing-cafe-counter_1262-1952.jpg?semt=ais_hybrid&w=740&q=80",
      title: "Ali's Success Story",
      text: "The books program provided me with essential learning materials. I'm now excelling in my studies and dream of becoming an engineer to help others like me."
    }
  ];

  return (
    <section className="testi-section">
      <div className="testi-container">
        {/* Header */}
        <div className="testi-header">
          <p className="testi-tag">Hear from our supporters</p>
          <h2 className="testi-title">
            Voices of impact.<br />
            Our supporters share stories
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="testi-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testi-card">
              {/* Stars */}
              <div className="testi-stars">
                {[...Array(5)].map((_, index) => (
                  <FaStar key={index} className="testi-star-icon" />
                ))}
              </div>

              {/* Title */}
              <h3 className="testi-card-title">{testimonial.title}</h3>

              {/* Description */}
              <p className="testi-text">{testimonial.text}</p>

              {/* Profile */}
              <div className="testi-profile">
                <div className="testi-profile-image">
                  <img src={testimonial.image} alt={testimonial.name} />
                </div>
                <div className="testi-profile-info">
                  <h4 className="testi-profile-name">{testimonial.name}</h4>
                  <p className="testi-profile-role">{testimonial.role}</p>
                </div>
              </div>

              {/* Quote Mark */}
              <div className="testi-quote-mark">"</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;